"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const KonvaShapes = Object.freeze({
    CIRCLE: "Circle",
    LINE: "Line",
    ARROW: "Arrow",
    RECTANGLE: "Rect",
    ELLIPSE: "Ellipse",
    POLYGON: "Polygon",
    TEXT: "Text",
    GROUP: "Group"
});
const _default = KonvaShapes;
